module.exports = __webpack_public_path__ + "static/media/Baeckerei_tn.7f0c781a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/Baeckerei_tn.jpg
// module id = 668
// module chunks = 0